function repeatOften() {
  const checkpoint = 730 / 2;
  const currentScroll = window.pageYOffset;

  if (currentScroll <= checkpoint) {
    var opacity = currentScroll / checkpoint;
  } else {
    opacity = 1;
  }

  document.documentElement.style.setProperty('--header-after-opacity', opacity);

  requestAnimationFrame(repeatOften);
}
if (window.location.href.indexOf('.test') === -1) {
  requestAnimationFrame(repeatOften);
}
